module.exports = __webpack_public_path__ + "img/news.4e9a7f55.png";